const productData = [
  {
    id: 1,
    name: "Indoor Cam Plus",
    category: "Indoor Cameras",
    price: "39.99",
    reviews: "861",
    rating: "4.5",
    image: "/img/101.jpg",
    images: [
      "/img/101.jpg",
      "/img/101a.jpg",
      "/img/101b.jpg",
      "/img/101c.jpg",
      "/img/101d.jpg",
    ],
    size: ["1-pack", "2-pack"],
    colors: ["White", "Black"],
    material: "Plastic housing, aluminum stand",
    description: [
      "Compact plug‑in indoor camera designed for everyday home monitoring.",
      "Retinal 2K image quality with enhanced zoom for crisp details across rooms.",
      "Low‑light optimization preserves sharp black‑and‑white detail in darkness.",
      "Real‑time notifications and quick access to Live View from the Rivergrove App.",
      "Privacy-first design with easy-to-slide lens cover and customizable zones.",
    ],
    Features: [
      "2K video with digital zoom",
      "Color video in daylight, detailed black‑and‑white at night",
      "Motion alerts with adjustable sensitivity",
      "Two‑Way Talk with noise reduction",
      "Privacy shutter with status indicator",
      "Dual‑band Wi‑Fi and quick plug‑in setup",
    ],
  },
  {
    id: 2,
    name: "Indoor Cam, 2nd Gen",
    category: "Indoor Cameras",
    price: "79.99",
    reviews: "702",
    rating: "4.6",
    image: "/img/102.jpg",
    images: ["/img/102.jpg", "/img/102a.jpg", "/img/102b.jpg"],
    size: ["1-pack", "2-pack"],
    colors: ["White", "Black"],
    material: "Matte polycarbonate",
    description: [
      "Refreshed compact indoor camera with upgraded image pipeline and processing.",
      "Designed to blend into shelves and countertops while keeping an eye on home.",
      "Quick setup through the Rivergrove App with guided mounting and placement tips.",
      "Works with Alexa for voice control and picture-in-picture on Echo devices.",
      "Customizable privacy zones reduce recording of areas you don't want captured.",
    ],
    Features: [
      "HD video with improved clarity",
      "Two‑Way Talk and Live View",
      "Motion-activated notifications",
      "Privacy zones and camera disable toggle",
      "Works with Alexa routines",
      "Secure account controls and alerts",
    ],
  },
  {
    id: 3,
    name: "Outdoor Cam",
    category: "Outdoor Cameras",
    price: "79.99",
    reviews: "214",
    rating: "4.5",
    image: "/img/103.jpg",
    images: [
      "/img/103.jpg",
      "/img/103a.jpg",
      "/img/103b.jpg",
      "/img/103c.jpg",
      "/img/103d.jpg",
    ],
    size: ["1-pack"],
    colors: ["White", "Black"],
    material: "Weather‑resistant housing",
    description: [
      "Weather‑resistant outdoor camera built to withstand sun, rain, and wind.",
      "Wide field of view keeps driveways, yards, and side entrances in frame.",
      "Smart motion detection helps reduce false alerts from passing branches.",
      "Connects to the Rivergrove App for live checks and event history with a plan.",
      "Flexible mount for wall or eave placement with included hardware.",
    ],
    Features: [
      "Full HD video with wide‑angle lens",
      "Custom motion zones and schedules",
      "Two‑Way Talk with noise cancellation",
      "Works with Rivergrove Protect for video history",
      "Simple installation with adjustable mount",
      "Durable, weather‑resistant materials",
    ],
  },
  {
    id: 4,
    name: "Battery Doorbell",
    category: "Doorbells",
    price: "99.99",
    reviews: "178",
    rating: "4.6",
    image: "/img/104.jpg",
    images: [
      "/img/104.jpg",
      "/img/104a.jpg",
      "/img/104b.jpg",
      "/img/104c.jpg",
      "/img/104d.jpg",
      "/img/104e.jpg",
      "/img/104f.jpg",
    ],
    size: ["1-pack"],
    colors: ["Satin Nickel", "Black"],
    material: "Metal faceplate, polymer body",
    description: [
      "Battery‑powered video doorbell for front doors and gates without wiring.",
      "Sharp HD video with motion alerts when visitors press or approach.",
      "Quick‑release battery pack for convenient charging and swaps.",
      "Dual‑band Wi‑Fi and improved range for reliable connectivity.",
      "Pairs with Chime or Alexa devices to Rivergrove throughout your home.",
    ],
    Features: [
      "HD video and Live View",
      "Two‑Way Talk with Quick Replies",
      "Custom motion zones and privacy options",
      "Quick‑release rechargeable battery",
      "Dual‑band Wi‑Fi support",
      "Easy self‑install with mounting kit",
    ],
  },
  {
    id: 5,
    name: "Floodlight Cam Plus",
    category: "Outdoor Cameras",
    price: "179.99",
    reviews: "305",
    rating: "4.8",
    image: "/img/105.jpg",
    images: [
      "/img/105.jpg",
      "/img/105a.jpg",
      "/img/105b.jpg",
      "/img/105c.jpg",
      "/img/105d.jpg",
      "/img/105e.jpg",
    ],
    size: ["1-pack"],
    colors: ["White", "Black"],
    material: "Metal light heads, weather‑resistant body",
    description: [
      "Hardwired outdoor camera with powerful dual floodlights for bright illumination.",
      "Built‑in motion‑activated lights deter intruders and light pathways at night.",
      "Advanced motion detection with customizable zones reduces false triggers.",
      "Loud security siren can be activated from the Rivergrove App when needed.",
      "Integrates with other Rivergrove devices for whole‑home awareness.",
    ],
    Features: [
      "1080p video with HDR",
      "Two adjustable LED floodlights",
      "Motion‑activated recording and lights",
      "Built‑in security siren",
      "Two‑Way Talk with noise reduction",
      "Hardwired installation with mounting kit",
    ],
  },
  {
    id: 6,
    name: "Wired Doorbell Pro (Newest Model)",
    category: "Doorbells",
    price: "249.99",
    reviews: "198",
    rating: "4.4",
    image: "/img/106.jpg",
    images: ["/img/106.jpg", "/img/106a.jpg"],
    size: ["1-pack"],
    colors: ["Satin Nickel", "Black"],
    material: "Premium faceplates, metal trim",
    description: [
      "Wired premium video doorbell with crisp video and head‑to‑toe viewing.",
      "Advanced motion detection and 3D perspective reduce unwanted alerts.",
      "Pre‑roll previews provide context before motion events.",
      "Pairs with existing chime wiring for continuous power.",
      "Enhanced privacy and encryption settings for secure operation.",
    ],
    Features: [
      "High‑definition video and color pre‑roll",
      "3D Motion Detection with Bird’s Eye View",
      "Two‑Way Talk with noise cancellation",
      "Dual‑band Wi‑Fi for stronger connection",
      "Customizable privacy zones",
      "Requires existing doorbell wiring",
    ],
  },
  {
    id: 7,
    name: "Chime Pro",
    category: "Accessories",
    price: "59.99",
    reviews: "240",
    rating: "4.7",
    image: "/img/107.jpg",
    images: ["/img/107.jpg", "/img/107a.jpg", "/img/107b.jpg", "/img/107c.jpg"],
    size: ["1-pack"],
    colors: ["White"],
    material: "Plug‑in module",
    description: [
      "Plug‑in chime and Wi‑Fi extender designed for Rivergrove Doorbells and Cameras.",
      "Adds audible alerts throughout the home with classic and seasonal tones.",
      "Helps improve device connectivity on the same network SSID.",
      "Simple plug‑in setup—pair in the Rivergrove App and choose tones and volume.",
      "Do Not Disturb schedules quiet notifications when needed.",
    ],
    Features: [
      "Multiple chime tones with volume control",
      "Dual‑band Wi‑Fi extender for compatible Rivergrove devices",
      "Do Not Disturb scheduling",
      "LED status indicator",
      "Compact plug‑in design",
      "Easy pairing in the Rivergrove App",
    ],
  },
  {
    id: 8,
    name: "Quick Release Battery Pack",
    category: "Accessories",
    price: "34.99",
    reviews: "190",
    rating: "4.8",
    image: "/img/108.jpg",
    images: ["/img/108.jpg", "/img/108a.jpg", "/img/108b.jpg", "/img/108c.jpg"],
    size: ["1-pack"],
    colors: ["Black"],
    material: "Rechargeable battery module",
    description: [
      "Spare rechargeable battery pack compatible with select Rivergrove Doorbells and Cameras.",
      "Quick‑release latch enables fast swaps without removing the whole device.",
      "LED indicators show charging and readiness status at a glance.",
      "Ideal for keeping a device powered while another battery charges.",
      "Compact design stores easily in drawers or gear bags.",
    ],
    Features: [
      "Tool‑free quick‑release mechanism",
      "Long‑lasting rechargeable cells",
      "Status LEDs for charge level",
      "Works with supported Rivergrove battery products",
      "Lightweight and compact",
      "Easy slide‑in installation",
    ],
  },
  {
    id: 9,
    name: "Spotlight Cam Plus",
    category: "Outdoor Cameras",
    price: "134.99",
    reviews: "256",
    rating: "4.7",
    image: "/img/109.jpg",
    images: ["/img/109.jpg", "/img/109a.jpg", "/img/109b.jpg", "/img/109c.jpg"],
    size: ["1-pack"],
    colors: ["White", "Black"],
    material: "Weather‑resistant body, LED spotlights",
    description: [
      "Versatile outdoor camera with motion‑activated spotlights for added visibility.",
      "Crystal‑clear video with HDR keeps details sharp in daylight and at night.",
      "Activate the built‑in siren from the Rivergrove App to deter unwanted visitors.",
      "Flexible power options and mounts fit porches, side yards, and garages.",
      "Integrates with other Rivergrove devices and Alexa for hands‑free control.",
    ],
    Features: [
      "1080p HDR video and Live View",
      "Motion‑activated dual LED spotlights",
      "Two‑Way Talk and remote siren",
      "Custom motion zones and schedules",
      "Weather‑resistant design",
      "Works with Rivergrove Protect for video history",
    ],
  },
  {
    id: 10,
    name: "2-Pack Spotlight Cam Pro",
    category: "Outdoor Cameras",
    price: "349.99",
    reviews: "312",
    rating: "4.9",
    image: "/img/1010.jpg",
    images: [
      "/img/1010.jpg",
      "/img/1010a.jpg",
      "/img/1010b.jpg",
      "/img/1010c.jpg",
      "/img/1010d.jpg",
    ],
    size: ["2-pack"],
    colors: ["White", "Black"],
    material: "Weather‑resistant body, LED spotlights",
    description: [
      "Pro‑grade outdoor camera bundle with two Spotlight Cam Pro units.",
      "3D Motion Detection and Bird’s Eye View deliver precise motion context.",
      "Improved audio with array microphones enhances Two‑Way Talk clarity.",
      "HDR video and color night vision help reveal details around your home.",
      "Ideal for covering multiple entry points with unified control in the app.",
    ],
    Features: [
      "Bundle of two Spotlight Cam Pro devices",
      "3D Motion Detection with Bird’s Eye View",
      "HDR video, color night vision",
      "Remote-activated security siren",
      "Dual‑band Wi‑Fi for stronger connections",
      "Customizable motion zones and schedules",
    ],
  },
  {
    id: 11,
    name: "Smart Plug",
    category: "Lighting",
    price: "24.99",
    reviews: "198",
    rating: "4.6",
    image: "/img/1011.jpg",
    images: ["/img/1011.jpg", "/img/1011a.jpg"],
    size: ["1-pack"],
    colors: ["White"],
    material: "Plug‑in module",
    description: [
      "Plug‑in Smart Lighting controller that turns standard fixtures into smart lights.",
      "Works with the Rivergrove Bridge for schedules, groups, and motion‑activated routines.",
      "Compact design leaves space for the second outlet on most wall plates.",
      "Control connected lights from the Rivergrove App or with Alexa voice commands.",
      "Great for indoor lamps, holiday decor, and accent lighting.",
    ],
    Features: [
      "On/Off control from the Rivergrove App",
      "Schedules and groups with Rivergrove Bridge",
      "Works with Alexa voice control",
      "Compact plug‑in form factor",
      "Status indicator LED",
      "Easy pairing and setup",
    ],
  },
  {
    id: 12,
    name: "Window & Door Sensor (Newest Model)",
    category: "Alarms and Sensors",
    price: "29.99",
    reviews: "267",
    rating: "4.5",
    image: "/img/1012.jpg",
    images: ["/img/1012.jpg", "/img/1012a.jpg"],
    size: ["1-pack"],
    colors: ["White"],
    material: "Magnet and contact sensor",
    description: [
      "Compact contact sensor that monitors the open/close status of doors and windows.",
      "Pairs with the Rivergrove Alarm system to trigger alerts and automation routines.",
      "Low‑profile design blends into frames and trim with adhesive or screws.",
      "Long battery life with simple tool‑free battery replacement.",
      "Add to entryways, sash windows, and interior doors for whole‑home coverage.",
    ],
    Features: [
      "Open/close status monitoring",
      "Instant alerts through the Rivergrove App",
      "Easy adhesive or screw mount",
      "Long‑life replaceable battery",
      "Works with Rivergrove Alarm and modes",
      "Compact, low‑profile design",
    ],
  },
  {
    id: 13,
    name: "Smart Light Remote",
    category: "Lighting",
    price: "29.99",
    reviews: "223",
    rating: "4.6",
    image: "/img/1013.jpg",
    images: ["/img/1013.jpg", "/img/1013a.jpg", "/img/1013b.jpg"],
    size: ["1-pack"],
    colors: ["Black"],
    material: "Handheld remote",
    description: [
      "Handheld remote that controls compatible Rivergrove Smart Lighting groups.",
      "Activate lights, adjust brightness, and trigger linked actions from one place.",
      "Perfect for bedside tables, entry consoles, or patios for quick lighting control.",
      "Long battery life with tactile buttons that are easy to find in the dark.",
      "Pairs in seconds with the Rivergrove Bridge and Rivergrove App.",
    ],
    Features: [
      "Group on/off and brightness control",
      "Quick access buttons with tactile feedback",
      "Long‑life replaceable battery",
      "Works with Rivergrove Bridge and Alexa routines",
      "Compact, portable design",
      "Simple pairing and management in app",
    ],
  },
  {
    id: 14,
    name: "Panic Button (Newest Model)",
    category: "Alarms and Sensors",
    price: "29.99",
    reviews: "198",
    rating: "4.7",
    image: "/img/1014.jpg",
    images: ["/img/1014.jpg", "/img/1014a.jpg"],
    size: ["1-pack"],
    colors: ["White"],
    material: "Handheld alarm accessory",
    description: [
      "Dedicated Panic Button for Rivergrove Alarm that sends an alert when pressed.",
      "Configurable to trigger emergency response with a compatible plan.",
      "Place on nightstands or walls for fast access during emergencies.",
      "LED confirmation and audible chirp indicate a successful press.",
      "Replaceable battery with tamper detection.",
    ],
    Features: [
      "One‑press alert activation",
      "Optional professional monitoring integration",
      "Wall mount or tabletop placement",
      "LED and audible feedback",
      "Tamper detection and event history",
      "Tool‑free battery replacement",
    ],
  },
  {
    id: 15,
    name: "Smart Light Switch (Newest Model)",
    category: "Lighting",
    price: "29.99",
    reviews: "312",
    rating: "4.8",
    image: "/img/1015.jpg",
    images: ["/img/1015.jpg", "/img/1015a.jpg", "/img/1015b.jpg"],
    size: ["1-pack"],
    colors: ["White"],
    material: "In‑wall smart switch",
    description: [
      "In‑wall Smart Lighting switch that upgrades existing fixtures to smart control.",
      "Works with the Rivergrove Bridge for scheduling, groups, and motion‑activated actions.",
      "Low‑profile design with smooth paddle and soft status LED.",
      "Control from the Rivergrove App or with Alexa voice commands.",
      "Neutral wire required for most installations.",
    ],
    Features: [
      "On/Off control with schedules",
      "Groups and linked actions via Rivergrove Bridge",
      "Alexa voice control compatibility",
      "Soft‑glow status indicator",
      "Standard in‑wall form factor",
      "Guided installation in the Rivergrove App",
    ],
  },
  {
    id: 16,
    name: "Temperature & Humidity Sensor",
    category: "Alarms and Sensors",
    price: "34.99",
    reviews: "187",
    rating: "4.7",
    image: "/img/1016.jpg",
    images: ["/img/1016.jpg", "/img/1016a.jpg"],
    size: ["1-pack"],
    colors: ["White"],
    material: "Environmental sensor",
    description: [
      "Sensor that tracks temperature and humidity to help protect sensitive spaces.",
      "Create alerts when conditions go outside your chosen range.",
      "Great for nurseries, basements, garages, and storage areas.",
      "Pairs with Rivergrove Alarm for modes, history, and automation.",
      "Compact design with adhesive or screw mounting.",
    ],
    Features: [
      "Temperature and humidity monitoring",
      "Customizable threshold alerts",
      "Adhesive or screw mounting options",
      "Long‑life replaceable battery",
      "Works with Rivergrove Alarm and routines",
      "Event history in the Rivergrove App",
    ],
  },
  {
    id: 17,
    name: "Flood & Freeze Sensor (Newest Model)",
    category: "Alarms and Sensors",
    price: "39.99",
    reviews: "234",
    rating: "4.6",
    image: "/img/1017.jpg",
    images: ["/img/1017.jpg", "/img/1017a.jpg"],
    size: ["1-pack"],
    colors: ["White"],
    material: "Water and temperature probe",
    description: [
      "Water leak and low‑temperature sensor for kitchens, basements, and bathrooms.",
      "Instant alerts when water is detected or temperatures drop too low.",
      "Place near sinks, water heaters, and appliances for early warning.",
      "No tools required—compact design fits tight spaces.",
      "Pairs with Rivergrove Alarm for history and notifications.",
    ],
    Features: [
      "Leak detection and low‑temperature alerts",
      "Loud chirp and in‑app notifications",
      "Battery powered with long life",
      "Tool‑free placement in tight spaces",
      "Works with Rivergrove Alarm and modes",
      "Event history and status checks",
    ],
  },
  {
    id: 18,
    name: "Motion Detector (Newest Model)",
    category: "Alarms and Sensors",
    price: "39.99",
    reviews: "201",
    rating: "4.6",
    image: "/img/1018.jpg",
    images: ["/img/1018.jpg", "/img/1018a.jpg"],
    size: ["1-pack"],
    colors: ["White"],
    material: "PIR motion sensor",
    description: [
      "Pet‑friendly motion detector that works with the Rivergrove Alarm system.",
      "Adjust sensitivity and set schedules to reduce unwanted activations.",
      "Wide coverage is ideal for halls and living spaces.",
      "Tool‑free battery replacement keeps maintenance simple.",
      "Triggers automation and alerts when motion is detected.",
    ],
    Features: [
      "Passive infrared motion sensing",
      "Pet‑friendly sensitivity options",
      "Quick mounting with adhesive or screws",
      "Long‑life replaceable battery",
      "Works with Rivergrove Alarm and modes",
      "Real‑time notifications in app",
    ],
  },
  {
    id: 19,
    name: "Outside Door Sensor (Newest Model)",
    category: "Alarms and Sensors",
    price: "39.99",
    reviews: "276",
    rating: "4.8",
    image: "/img/1019.jpg",
    images: ["/img/1019.jpg", "/img/1019a.jpg"],
    size: ["1-pack"],
    colors: ["White"],
    material: "Outdoor contact sensor",
    description: [
      "Ruggedized contact sensor designed for exterior gates, sheds, and doors.",
      "Weather‑resistant enclosure withstands rain, sun, and temperature swings.",
      "Large magnet gap tolerance works with non‑flush surfaces.",
      "Pairs with Rivergrove Alarm to trigger alerts and routines outdoors.",
      "Simple mounting with included hardware.",
    ],
    Features: [
      "Outdoor‑rated open/close monitoring",
      "Wide magnet gap tolerance",
      "Weather‑resistant housing",
      "Works with Rivergrove Alarm modes",
      "Tool‑free battery replacement",
      "Reliable long‑range wireless link",
    ],
  },
  {
    id: 20,
    name: "Car Alarm",
    category: "Accessories",
    price: "49.99",
    reviews: "189",
    rating: "4.6",
    image: "/img/1020.jpg",
    images: [
      "/img/1020.jpg",
      "/img/1020a.jpg",
      "/img/1020b.jpg",
      "/img/1020c.jpg",
    ],
    size: ["1-pack"],
    colors: ["Black"],
    material: "OBD‑II connected module",
    description: [
      "Vehicle security add‑on that sends alerts from your car to the Rivergrove App.",
      "Detects break‑in events like bumps, tows, and attempted intrusions.",
      "Integrates with Alexa and Rivergrove devices for linked detections at home.",
      "Installs in the OBD‑II port on most cars in minutes.",
      "Optional LTE accessory keeps alerts working when the car is parked away from Wi‑Fi.",
    ],
    Features: [
      "Bump, tow, and break‑in detection",
      "Real‑time notifications in the Rivergrove App",
      "Linked events with Rivergrove home devices",
      "Quick OBD‑II installation on most cars",
      "Optional cellular accessory for coverage",
      "Manageable alerts and history",
    ],
  },
];

export default productData;
